export const EMPTY_ACTION = () => {
  console.log('Empty action');
};
